module.exports = __webpack_public_path__ + "img/4.79d2ab10.jpg";